<template>
    <div>
        <b-modal
            id="modal-electronic-invoice"
            no-close-on-backdrop
            size="md"
            :title="i18nT(`Electronic invoice`)"
            @hidden="resetForm"
        >
            <p class="mb-2">
                {{ i18nT(`Please confirm the details below to send this invoice as an electronic invoice.`) }}
            </p>

            <b-card no-body class="py-1 px-2">
                <div class="d-flex flex-wrap">
                    <div class="transaction-detail mr-2">
                        <strong>{{ i18nT(`Invoice #`) }}</strong>
                        <p>
                            <span v-if="invoice.Prefix">{{ invoice.Prefix }}{{ invoice.InvoiceNumber }}</span>
                            <span v-else>{{ invoice.InvoiceNumber }}</span>
                        </p>
                    </div>

                    <div class="transaction-detail mr-2">
                        <strong>{{ i18nT(`Date`) }}</strong>
                        <p>{{ invoice.InvoiceDate | date }}</p>
                    </div>

                    <div v-if="invoice.VendorObj" class="transaction-detail mr-2">
                        <strong>{{ i18nT(`Client`) }}</strong>
                        <p>{{ invoice.VendorObj.Label }}</p>
                    </div>
                </div>

                <div class="d-flex flex-wrap">
                    <div class="transaction-detail mr-2">
                        <strong>{{ i18nT(`Total Amount`) }}</strong>
                        <p>{{ {amount: invoice.TotalAmount, currency: invoice.Currency} | currency }}</p>
                    </div>
                </div>
            </b-card>

            <template #modal-footer>
                <div class="d-flex justify-content-end">
                    <b-button
                        variant="outline-secondary"
                        class="mr-2"
                        :disabled="isLoading"
                        @click="cancel"
                    >
                        {{ i18nT(`Cancel`) }}
                    </b-button>

                    <b-button
                        variant="primary"
                        :disabled="isLoading"
                        @click="confirm"
                    >
                        {{ i18nT(`Confirm`) }}
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {BButton, BCard, BModal} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    name: "ModalElectronicInvoice",
    components: {
        BModal,
        BCard,
        BButton,
    },
    props: {
        invoice: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isLoading: false,
        }
    },
    methods: {
        cancel() {
            this.$bvModal.hide('modal-electronic-invoice');
        },
        resetForm() {
            this.isLoading = false;
        },
        confirm() {
            this.isLoading = true;

            this.$http.post(`invoices/electronicInvoice?invoice_id=${this.invoice.Id}`).then((response) => {
                this.isLoading = false;

                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: this.successMessage(response),
                        icon: 'CheckIcon',
                        variant: 'success',
                    },
                });

                this.$bvModal.hide('modal-electronic-invoice');
                this.$emit('updated');
            }).catch((error) => {
                this.isLoading = false;

                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: this.errorMessage(error),
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                });
            })
        },
    },
}
</script>

<style scoped>
.transaction-detail {
    min-width: 120px;
}
</style>
